import type { WikiSettingSchedule } from './schema';

import { WikiSettingScheduleSchema } from './schema';

export type WikiRefreshTier = 'scan_access' | 'paid' | 'free';
export type WikiAutoRefreshPlanTier = 'pro' | 'team' | 'free';
export const WIKI_AUTO_REFRESH_SCHEDULES = [...WikiSettingScheduleSchema.options];

export function getWikiRefreshTier(hasScanAccess: boolean, hasPaidPlan: boolean): WikiRefreshTier {
  if (hasScanAccess) {
    return 'scan_access';
  }
  if (hasPaidPlan) {
    return 'paid';
  }
  return 'free';
}

export function getWikiAutoRefreshPlanTier(
  hasScanAccess: boolean,
  hasPaidPlan: boolean,
): WikiAutoRefreshPlanTier {
  if (hasScanAccess) {
    return 'pro';
  }
  if (hasPaidPlan) {
    return 'team';
  }
  return 'free';
}

export function isWikiAutoRefreshEntitled(hasScanAccess: boolean, hasPaidPlan: boolean): boolean {
  return hasScanAccess || hasPaidPlan;
}

export function getAllowedWikiAutoRefreshSchedules(
  planTier: WikiAutoRefreshPlanTier,
): WikiSettingSchedule[] {
  if (planTier === 'pro') {
    return ['daily', 'weekly', 'monthly'];
  }

  if (planTier === 'team') {
    return ['monthly'];
  }

  return [];
}

export function getDefaultWikiAutoRefreshSchedule(
  planTier: WikiAutoRefreshPlanTier,
): WikiSettingSchedule {
  return planTier === 'team' ? 'monthly' : 'weekly';
}

export function isWikiAutoRefreshScheduleAllowedForPlan(
  schedule: string,
  planTier: WikiAutoRefreshPlanTier,
): boolean {
  const parsedSchedule = WikiSettingScheduleSchema.safeParse(schedule);
  if (!parsedSchedule.success) {
    return false;
  }

  return getAllowedWikiAutoRefreshSchedules(planTier).includes(parsedSchedule.data);
}

export function resolveWikiAutoRefreshScheduleForPlan(
  schedule: string,
  planTier: WikiAutoRefreshPlanTier,
): WikiSettingSchedule | null {
  const allowedSchedules = getAllowedWikiAutoRefreshSchedules(planTier);
  const parsedSchedule = WikiSettingScheduleSchema.safeParse(schedule);
  if (!parsedSchedule.success) {
    return null;
  }

  if (allowedSchedules.includes(parsedSchedule.data)) {
    return parsedSchedule.data;
  }

  if (allowedSchedules.length === 0) {
    return null;
  }

  return getDefaultWikiAutoRefreshSchedule(planTier);
}
